import React from "react";
import { Navigation } from "react-minimal-side-navigation";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";
import {MdAddToHomeScreen, MdImportantDevices} from "react-icons/md";
import {RiDeviceFill} from "react-icons/ri";
import { Nav } from "react-bootstrap";

export default class SideBar extends React.Component {
  render() {
    return (
      <Nav className="c-sidenav" id="sidenav">
        <Navigation
          activeItemId={this.props.getLocation.pathname}
          onSelect={({ itemId }) => {
            if (itemId != "/apps" && itemId != "/facilities") {
              this.props.navbarClick();
              this.props.setNavigate(itemId);
            }
          }}
          items={[
            {
              title: "Moje opravy",
              itemId: "/user/repair",
              elemBefore: () => <RiDeviceFill />,
            },
            {
              title: "Vytvořit požadavek",
              itemId: "/user/createRequest",
              elemBefore: () => <MdAddToHomeScreen />,
            },
            {
              title: "Otevřené požadavky",
              itemId: "/user/openRequest",
              elemBefore: () => <MdImportantDevices />,
            }
          ]}
        />
      </Nav>
    );
  }
}
